import React from 'react';
import { NewsContactContainer } from '../../containers/news/NewsContactContainer';
import { logNewsEvent } from '../../services/news';

/** Navigation page for the contact page in the news feature/subdomain */
export const NewsContactPage = () => {
    logNewsEvent("Contact");
    return <NewsContactContainer />;
}
